import { store } from "../store/store";
import { DEFAULT_MODULES, MODULE_KEYS } from "../constants/modules";

/* Which optional sections the current workspace has switched on.
 *
 * The answer belongs to the organization and comes down with it from the API —
 * it is a decision about the workspace, not about the browser it was clicked
 * in, so it has to hold on the next device and for the next colleague. The
 * panel uses it to hide the sidebar entry and the route. Nothing here is a
 * permission; the API enforces paid access independently.
 *
 * Reads the store directly, the same way `hasPermission` does, because the two
 * are used side by side in `getPermissionedMenuItems` and in the route table —
 * neither of which is a component. Inside a component that has to re-render on
 * a change, use `useModules`.
 */
export const enabledModules = () => {
  const organization = store.getState().auth?.organization;
  const stored = organization?.modules;

  /* Module preferences survive an expiry, but none of the paid sections is
   * effective until the organization has an active subscription again. */
  if (organization?.hasPlan !== true) return [];

  /* Absent means an organization that has never been asked — everything that
   * was visible before the picker existed stays visible. An explicit empty
   * array is a real answer and is left alone. */
  if (!Array.isArray(stored)) return DEFAULT_MODULES;

  return stored.filter((key) => MODULE_KEYS.includes(key));
};

export const isModuleEnabled = (key) => enabledModules().includes(key);

export default isModuleEnabled;
